<template>
  <section class="text-xs md:text-header-window">
    <div class="flex w-full text-xs items-center justify-center md:justify-start ml-px flex-wrap gap-4 md:min-w-80 md:ml-1">
      <div class="flex flex-col items-center flex-wrap">
        <img src="/img/icons/projects/tools/python.svg" :alt="$t('common.icon') + ' Python'" class="w-9 h-9" />
        <p class="font-bold mt-px">Python</p>
      </div>
      <div class="flex flex-col items-center flex-wrap">
        <img src="/img/icons/projects/tools/opencv.svg" :alt="$t('common.icon') + ' OpenCV'" class="w-9 h-9" />
        <p class="font-bold mt-px">OpenCV</p>
      </div>
    </div>
    <div class="mt-5 p-4 bg-yellow-100 border border-yellow-400 rounded text-yellow-800">
      <p class="font-bold">🚧 Project In Development</p>
      <p class="mt-1">This project is currently under construction.</p>
    </div>
    <h3 class="mt-5 mb-2 text-md">{{ $t('common.context') }}</h3>
    <p class="mb-2">{{ $t('project.weapons.contextFirstParagraph') }}</p>
    <p class="mb-2">{{ $t('project.weapons.contextSecondParagraph') }}</p>
    <p class="mb-2">{{ $t('project.weapons.contextThirdParagraph') }}</p>
    <h3 class="mt-5 mb-2">{{ $t('common.objectives') }}</h3>
    <ul class="list-disc ml-3">
      <li>{{ $t('project.weapons.goalFirst') }}</li>
      <li>{{ $t('project.weapons.goalSecond') }}</li>
      <li>{{ $t('project.weapons.goalThird') }}</li>
      <li>{{ $t('project.weapons.goalFourth') }}</li>
      <li>{{ $t('project.weapons.goalFifth') }}</li>
      <li>{{ $t('project.weapons.goalSixth') }}</li>
    </ul>
    <div class="mt-5">
      <img src="/img/projects/weapons/hamster2.jpg" :alt="'Placeholder - ' + ProjectName" class="w-full max-w-[750px] mb-2 rounded" />
    </div>
  </section>
</template>

<script setup>
let ProjectName = 'W.E.A.P.O.N.S: Weapon Detection System';
</script>
